import {room,Video,CONV_STORAGE, kinoParticipants, screenShare, spacesView, onStage} from './roomnew';
import Sibilant from './siblant-audio';
export default class Speaker {
    constructor() {
            this.lastSpeaker=null;
            this.currentSpeaker=null;
            this.participants={};
            this.speaking={};
            this.speakerCandidates={};
            this.speakerThreshold=1000;
            this.removeSpeakerThreshold=1300;
            this.btnLabel=``;
            this.btn='';
            this.btnSwitch='';
            this.speakerIcon = '<i class="icofont-street-view"></i>';
            this.enabled=localStorage.getItem('speaker_detection') ? localStorage.getItem('speaker_detection') : SPEAKER_DETECTION >= 0 ? SPEAKER_DETECTION : 1;
        };

     setEnabled(){
        var s=this;
        s.enabled=1;
        localStorage.setItem('speaker_detection',1);
    };
    setDisabled(){
        var s=this;
        s.enabled=0;
        localStorage.setItem('speaker_detection',0);
        s.removePreviousSpeaker();
    };
    addOptionButton(){
        var s=this;
        s.btnLabel=`Speaker Highlight&nbsp;&nbsp;`;
        s.btnSwitch = $('<label />', {
            class: 'switch',
            html: [`<input type="checkbox" id="speaker-highlight-checkbox" ${s.enabled > 0 ? 'checked' : ''}><span class="kino-slider round"></span>`],
        }).on('change','input', function(){
            if(s.enabled > 0){
                s.setDisabled();
            }else{
                s.setEnabled();
            }
        });

        // s.btn=$("<div>",{
        //     class:'dropdown-item',
        //     id:'speakerDetectionBtn',
        //     html:[`<div class="kinetx-icon"><i class="icofont-street-view"></i></div>`,s.btnLabel,s.btnSwitch]
        // }).on('click',function(e){
        //     e.stopPropagation();
        // });

        // $("#kino-options-list").find("#speakerDetectionBtn").remove();
        // $("#kino-options-list").prepend(s.btn);
        s.optionIcon = $('<div/>', {
            class: "option-icon",
            id: "speakerHighlightIcon",
            html: s.speakerIcon,
        });
        s.optionName = $('<div/>', {
            class: "option-name",
            id: "option-name-speakerHighlight",
            html: s.btnLabel,
        });
        s.optionAction = $('<div/>', {
            class: "option-action kino-toggle",
            id: "option-action-speakerHighlight",
            html: s.btnSwitch,
        });
        s.optionDescription = $('<div/>', {
            class: "option-description",
            html: [ s.optionName, s.optionAction],
        });
        s.btn = $('<label/>', {
            for: 'speaker-highlight-checkbox',
            class: 'option',
            id: 'speakerDetectionBtn',
            html: [s.optionIcon, s.optionDescription],
        }).on('click',function(e){
            e.stopPropagation();
        });

        $("#option-list").find("#speakerDetectionBtn").remove();
        $("#option-list").append(s.btn);
    };
    canChangeSpeaker(speaker_id){
        var s=this;
        if(Video.focused[speaker_id]!==undefined && Object.keys(Video.focused).length > 1){
            //console.log("canChangeSpeaker returning true because of focused");
            return true;}
            let myConversation=CONV_STORAGE.myConversation;
            let speakerConversation=CONV_STORAGE.isOnConversation(speaker_id);
            // console.log(`can change speaker speakerSpace = ${speakerConversation} , my space= ${myConversation}`)
        if(!speakerConversation && !myConversation){
            //console.log("canChangeSpeaker returning true because participant is not on a conversation");
            return true;
        }
        if(myConversation && myConversation == speakerConversation && kinoParticipants.inMySpace().length > 1){
            return true;
        }
        if(!myConversation && Object.keys(Video.focused).length > 0 && !speakerConversation){
            //console.log("canChangeSpeaker returning true because  lecturer case");
            return true;
        }
        //console.log("canChangeSpeaker returning false because participant is on a different conversation and i am not focused on him");
        return false;
    };

    attachEvent(id,stream){
        var s=this;
        try {
            s.participants[id] = new Sibilant(stream,{threshold:0,smoothing:0.5});
            s.participants[id].bind('speaking',()=>{
                if(s.canChangeSpeaker(id)){
                  //console.log("speaking id :"+id);
                  s.speakingEvent(id);  
                }
                
            });
            s.participants[id].bind('stoppedSpeaking',s.speakingStopEvent.bind(s,id));   
        } catch (error) {
            console.warn("Error attaching event to stream",error);
        }
       
        /*speakingEvents.bind('volumeChanged', function (data) {
                console.log(Video.videos[participant].displayName+':volume changed!', 'value:', data)
            });*/
    };

    removePreviousSpeaker(){
        var s=this;
        $(".videoViewContainer.speaking").removeClass('speaking');
        s.speaking={};
        s.speakerCandidates={};
    };
    
    changeSpeaker(speaker_id){
        var s=this;
        if(Video.videos[speaker_id]!==undefined){
            s.lastSpeaker=s.currentSpeaker;
            s.currentSpeaker=speaker_id;
            if(Video.sideParticipants[speaker_id]!==undefined){
                Video.moveSideVideoToTop(speaker_id);
            }
       
            Video.videos[speaker_id].viewContainer.addClass('speaking');
        }
        if(onStage.isActive()){
            let p = kinoParticipants.get(speaker_id)
            p.addSpeakerClass()
        }
    };

    speakingEvent(id){
        var s=this;
        if(s.enabled < 1){return}
        let nowTs=new Date().getTime();
        // console.log("speaking event from "+id);
        //is a speaker
        if(s.speaking[id]!==undefined){
            clearTimeout(s.speaking[id].removingTimeout);
            s.speaking[id].last_spoke=nowTs; 
            return
        } 

        //is a candidate
        if(s.speakerCandidates[id]!==undefined){
            if((nowTs-parseInt(s.speakerCandidates[id].start_at)) >= s.speakerThreshold){
                s.speaking[id]={start_at:nowTs,last_spoke:nowTs,removingTimeout:0};
                s.addSpeaker(id);
            }else{
                clearTimeout(s.speakerCandidates[id].removingTimeout);
                s.speakerCandidates[id].last_spoke=nowTs; 
            }
        }else{
            //add candidate
            s.speakerCandidates[id]={start_at:nowTs,last_spoke:nowTs,removingTimeout:0};
        }
        //console.log("spekaer status",s.speaking);
        //console.log("candidate status",s.speakerCandidates);

    };

    speakingStopEvent(id){
        var s=this;
        if(s.enabled < 1){return}
        //is a candidate
        if(s.speakerCandidates[id]!==undefined){
            // user is a candidate
            s.speakerCandidates[id].removingTimeout=setTimeout(() => {
                s.removeCandidate(id);
            }, s.removeSpeakerThreshold);
        }
        //is a speaker
        if(s.speaking[id]!==undefined){
            s.speaking[id].removingTimeout=setTimeout(() => {
                s.removeSpeaker(id);
            }, s.removeSpeakerThreshold);
        }
    };

    addSpeaker(id){
        var s=this;
        if(Video.videos[id]!==undefined){
            if(Video.sideParticipants[id]!==undefined){
                Video.moveSideVideoToTop(id);
            }
            Video.videos[id].viewContainer.addClass('speaking');
            screenShare.popup.speakerChanged(id);
        }
    };
     
    removeCandidate(id){
        var s=this;
        delete this.speakerCandidates[id];
    };
    
    removeSpeaker(id){
        var s=this;
        delete s.speaking[id];
        delete this.speakerCandidates[id];
        if(Video.videos[id]!==undefined){
            Video.videos[id].viewContainer.removeClass('speaking');
            screenShare.popup.removeSpeaker(id);
        }
        if(onStage.isActive()){
            let p = kinoParticipants.get(id)
            p.removeSpeakerClas()
        }
    };


    dominantSpeakerEvent(speaker){
        var s=this;
        
        if(speaker==s.currentSpeaker || s.enabled <= 1){return}
        // console.log("speaker event:"+speaker);
        if(s.canChangeSpeaker(speaker)){
            s.removePreviousSpeaker();
            s.changeSpeaker(speaker);
        }
    }
};